// extracted by mini-css-extract-plugin
export default {"checkbox":"ManagementFeesCheckbox_checkbox__iT9XK"};